import Plugin from '@ckeditor/ckeditor5-core/src/plugin';
import PasteCommand from './pastewithoutstyletagcommand';

/**
 * The main plugin class with the logic to use only the
 * plain text from the clipboard input.
 */
export default class PasteWithoutStyletag extends Plugin {
  static get pluginName() {
    return 'PasteAsPlainText';
  }

  static get requires() {
    return [ PasteCommand ];
  }

  init() {
    const editor = this.editor;
    editor.commands.add( 'PasteWithoutStyletag', new PasteCommand( editor ) );

    // Logic responsible for removing the style tag.
    const command = editor.commands.get( 'PasteWithoutStyletag' );
    const editingView = editor.editing.view;
    editingView.document.on( 'clipboardInput', ( evt, data ) => {
      if ( editor.isReadOnly || !command.value ) {
        return;
      }

      const dataTransfer = data.dataTransfer;
      let content = dataTransfer.getData( 'text/html' ).replace( /(<style[\w\W]+style>)/g, '' );

      const clipboardPlugin = editor.plugins.get( 'Clipboard' );
      content = clipboardPlugin._htmlDataProcessor.toView( content );
      clipboardPlugin.fire( 'inputTransformation', {
        content,
        dataTransfer,
        asPlainText: true
      } );

      editingView.scrollToTheSelection();
      evt.stop();
    } );
  }
}
